/* UbraTech theme glue: cart-count sync, AJAX add-to-cart for card/PDP buttons, finder open hooks. */
(function(){
  function setCartCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); }
    });
  }
  function toast(msg){
    var t = document.querySelector('.toast');
    if(!t){ t = document.createElement('div'); t.className='toast';
      t.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(t); }
    t.querySelector('span').textContent = msg || 'Added to cart';
    t.classList.add('on'); clearTimeout(t._h); t._h=setTimeout(function(){ t.classList.remove('on'); }, 2200);
  }
  function addToCart(id, qty){
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: id, quantity: qty||1 }] })
    }).then(function(r){ return r.json().then(function(d){ if(!r.ok){ throw d; } return d; }); })
      .then(function(){ return fetch('/cart.js').then(function(r){return r.json();}); })
      .then(function(cart){ setCartCount(cart.item_count); toast('Added to cart'); })
      .catch(function(e){ toast((e && e.description) || 'Could not add to cart'); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-variant]');
    if(btn){ e.preventDefault(); var id = btn.getAttribute('data-add-variant'); var q = parseInt(btn.getAttribute('data-qty')||'1',10); if(id) addToCart(id, q); }
  });
  if (window.UBRA && typeof window.UBRA.cartCount === 'number') setCartCount(window.UBRA.cartCount);
  window.UBRAaddToCart = addToCart;
})();
